/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';

export default function Icon({ title = null, color = null }) {
  return (
    <svg role="img" aria-labelledby="burgerMenuIcon" width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {title && <title id="burgerMenuIcon">{title}</title>}
      <path d="M4 6H20" stroke={color || '#585F69'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 12H20" stroke={color || '#585F69'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 18L20 18" stroke={color || '#585F69'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

Icon.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
};
